<app-dashboard-layout pageTitle="Dashboard">
  <div class="grid pb-8 gap-8 grid-cols-1 md:grid-cols-2">
    <div class="rounded-md bg-primary/10 p-20">STATS HERE</div>
    <div class="rounded-md bg-primary/10 p-20">STATS HERE</div>
  </div>

  <div class="rounded-md bg-primary/10 p-20 pb-48">RECENT ACTIVITIES HERE</div>
</app-dashboard-layout>
